// extracted by mini-css-extract-plugin
export default {"title":"ModalConfirmarRemoverParaMim_title__jhTc4","body":"ModalConfirmarRemoverParaMim_body__5NdpJ"};